import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    subjectTypes: [],
    markers: {},
    mailingGroups: {},
    markersLoading: false,
    markersLoaded: false,
    loadingError: false,
  },
  mutations,
  actions,
  getters,
}
